import { useNavigate } from 'react-router-dom';
import {
  PageHeader, DashboardCard, StatusBadge,
  Table, TableHeader, TableRow, TableHead, TableBody, TableCell,
} from '@zafroi/ui-kit';
import { useRateCards } from '@/hooks/useCommercial';
import { QueryStateGuard } from '@/components/common/QueryStateGuard';
import { catalogStatusVariants } from '@/config/commercial-status';
import { shortDate } from '@/lib/format';

export function RateCardsPage() {
  const navigate = useNavigate();
  const q = useRateCards();
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Setup" title="Rate Cards" description="Role-based rates for professional services." />
      <DashboardCard flushBody>
        <QueryStateGuard data={q.data} isLoading={q.isLoading} isError={q.isError} emptyTitle="No rate cards yet">
          {(data) => (
            <Table>
              <TableHeader><TableRow>
                <TableHead>Name</TableHead><TableHead>Currency</TableHead><TableHead className="text-right">Roles</TableHead>
                <TableHead>Status</TableHead><TableHead>Effective from</TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {data.map((x) => (
                  <TableRow key={x.id} className="cursor-pointer" onClick={() => navigate(`/setup/rate-cards/${x.id}`)}>
                    <TableCell className="font-medium">{x.name}</TableCell>
                    <TableCell>{x.currency}</TableCell>
                    <TableCell className="text-right tabular-nums">{x.entries?.length ?? 0}</TableCell>
                    <TableCell><StatusBadge status={x.status} variants={catalogStatusVariants} /></TableCell>
                    <TableCell className="text-muted-foreground">{x.effectiveFrom ? shortDate(x.effectiveFrom) : '—'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </QueryStateGuard>
      </DashboardCard>
    </div>
  );
}
